<template>
  <v-card elevation="2">
    <!-- <v-card-title>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Buscar"
        single-line
        hide-details
        clearable
      />
    </v-card-title> -->

    <v-data-table
      :headers="headers"
      :items="items"
      :search="search"
      :loading="loading"
      :options.sync="options"
      :footer-props="footerProps"
      :item-class="getRowClass"
      class="elevation-1 report-table"
      :loading-text="loadingText"
      @click:row="$emit('row-click', $event)"
    >
      <template v-slot:body="{ items }">
        <tbody>
          <template v-for="(item, index) in items">
            <!-- Fila principal -->
            <tr :key="`row-${item.id || index}`" class="main-row">
              <td>{{ index + 1 }}</td>
              <td>{{ item.cite }}</td>
              <td>
                <div>
                  <div class="text-caption">{{ item.userName }}</div>
                  <strong>{{ item.userPosition }}</strong>
                </div>
              </td>
              <td align="center">{{ item.unitDescription }}</td>
              <td align="center">
                <div>
                  <div class="text-caption">{{ item.location }}</div>
                  <div class="text-caption">{{ item.transportName }}</div>
                </div>
              </td>
              <td align="center">
                <div class="date-time-container">
                  <div class="text-caption">
                    {{ formatDate(item.startDate).split("\n")[0] }}
                  </div>
                  <div class="text-caption">
                    {{ formatDate(item.startDate).split("\n")[1] }}
                  </div>
                  <v-divider class="my-1"></v-divider>
                  <div class="text-caption">
                    {{ formatDate(item.endDate).split("\n")[0] }}
                  </div>
                  <div class="text-caption">
                    {{ formatDate(item.endDate).split("\n")[1] }}
                  </div>
                </div>
              </td>
              <td align="center">
                <div>
                  <div class="text-caption">{{ item.tripType }}</div>
                  <div class="text-caption">{{ item.resolution }}</div>
                </div>
              </td>

              <td align="center">{{ item.days }}</td>
              <td align="center">{{ item.state }}</td>
              <td align="center">
                <div class="text-caption">
                  {{
                    new Intl.NumberFormat("es-BO", {
                      minimumFractionDigits: 2,
                    }).format(item.totalAllowance)
                  }}
                </div>
              </td>
              <td align="center">
                <div class="text-caption">
                  {{
                    new Intl.NumberFormat("es-BO", {
                      minimumFractionDigits: 2,
                    }).format(item.totalTickets)
                  }}
                </div>
              </td>
            </tr>

            <!-- Fila de motivo (expandida) -->
            <tr :key="`motive-${item.id || index}`" class="motive-row">
              <td colspan="100%" class="pa-2">
                <div class="motive-container">
                  <div class="motive-content">
                    <strong>Motivo:</strong>
                    {{ item.motive || "No especificado" }}
                  </div>
                </div>
              </td>
            </tr>
          </template>
        </tbody>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { format, parseISO } from "date-fns";
import { es } from "date-fns/locale";

export default {
  name: "ReportTable",
  props: {
    headers: {
      type: Array,
      required: true,
    },
    items: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    search: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
      },
      footerProps: {
        "items-per-page-options": [10, 20, 50, 100, -1],
        "items-per-page-text": "Registros por página",
        "show-current-page": true,
        "show-first-last-page": true,
        "page-text": "{0}-{1} de {2}",
      },
      loadingText: "Cargando reporte...",
    };
  },
  methods: {
    formatDate(dateString) {
      if (!dateString) return "N/A\nN/A";
      try {
        const date = new Date(dateString);
        const datePart = date.toLocaleDateString("en-GB");
        const timePart = date.toLocaleTimeString("en-GB", {
          hour: "2-digit",
          minute: "2-digit",
        });
        return `${datePart}\n${timePart}`;
      } catch (error) {
        return "N/A\nN/A";
      }
    },
    getRowClass(item) {
      console.log(item);
      return item.days > 10 ? "highlight-row" : "";
    },
  },
};
</script>

<style scoped>
.report-table {
  background: rgba(255, 255, 255, 0.9);
}

.date-time-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
}

.date-time-container .text-caption {
  line-height: 1.2;
  white-space: nowrap;
}

.text-caption {
  font-size: 0.8rem;
  line-height: 1.2;
}

.motive-row {
  background-color: #f9f9f9;
  border-bottom: 2px solid #e0e0e0;
}

.motive-container {
  padding: 2px;
}

.motive-content {
  margin-top: 2px;
  padding: 10px;
  background-color: white;
  border: 1px solid #eee;
  border-radius: 8px;
  white-space: pre-line;
}

.highlight-row {
  background-color: #fffde7 !important;
}

.main-row:hover {
  background-color: #f5f5f5 !important;
  cursor: pointer;
}
</style>
